import { DISMISS_MODAL, OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL, OPEN_SEND_SELLER_MESSAGE_MODAL } from './actions';
import { getAuthToken, getBidderId } from './user';
import api from '@/redux/api/conversationMessages';
import apiOld from '@/redux/api/seller';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const SEND_SELLER_MESSAGE_FAIL = 'la/ui/sendSellerMessage/FAIL';
export const SEND_SELLER_MESSAGE_REQUEST = 'la/ui/sendSellerMessage/REQUEST';
export const SEND_SELLER_MESSAGE_SUCCESS = 'la/ui/sendSellerMessage/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    messageDetails: {},
    sellerId: 0,
    sellerName: '',
    subject: '',
    submitted: false,
    success: false,
    title: '',
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return {
                ...state,
                messageDetails: action.payload.messageDetails,
                sellerId: action.payload.sellerId,
                sellerName: action.payload.sellerName,
                subject: action.payload.subject,
                title: action.payload.title,
            };
        case SEND_SELLER_MESSAGE_REQUEST:
            return {
                ...state,
                error: false,
                submitted: true,
                success: false,
            };
        case DISMISS_MODAL:
            return {
                ...state,
                messageDetails: {},
                sellerId: 0,
                sellerName: '',
                subject: '',
                success: false,
                title: '',
            };
        case SEND_SELLER_MESSAGE_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case SEND_SELLER_MESSAGE_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.sendSellerMessage;

export const getUiSendSellerMessage = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const submitSendSellerMessage = (messageDetails: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: SEND_SELLER_MESSAGE_REQUEST,
        });
        const response = await apiOld.postMessage({ authToken, deployment, messageDetails });
        dispatch({
            payload: response,
            type: SEND_SELLER_MESSAGE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: SEND_SELLER_MESSAGE_FAIL,
        });
    }
};

export const submitStartConversation = (messageDetails: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);

        const { catalogId, itemId, message, sellerId, subject } = messageDetails;

        dispatch({
            type: SEND_SELLER_MESSAGE_REQUEST,
        });
        const response = await api.startConversationMessage({
            authToken,
            bidderId,
            catalogId,
            deployment,
            houseId: sellerId,
            lotId: itemId,
            messageBody: message,
            subject,
        });
        dispatch({
            payload: response,
            type: SEND_SELLER_MESSAGE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: SEND_SELLER_MESSAGE_FAIL,
        });
    }
};

export const startConversationWithAttachment = ({
    attachments,
    messageBody,
    sellerId,
    subject,
}: {
    attachments: Array<any>;
    messageBody: string;
    sellerId: number;
    subject: string;
}) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);

        dispatch({
            type: SEND_SELLER_MESSAGE_REQUEST,
        });
        const response = await api.startConversationWithAttachment({
            attachments: attachments,
            authToken,
            bidderId,
            deployment,
            messageBody,
            sellerId,
            subject,
        });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: SEND_SELLER_MESSAGE_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: SEND_SELLER_MESSAGE_FAIL,
        });
    }
};
